import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import useSubscribeRefresh  from 'use-subscribe-actions'

import Kpis from './Kpis'
import Table from './Table'
import Filters from './Filters'

const Dashboard = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  useSubscribeRefresh(() => navigate('/projects'))
  return (
    <Stack gap={3}>
      <Kpis />
      <Stack
        gap={2}
      >
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography component={'span'} sx={{fontSize: 13, fontWeight: 600}}>{t('projects.kpis.project')}</Typography>
          <Filters />
        </Stack>
        <Table />
      </Stack>
    </Stack>
  )
}

export default Dashboard